import styled from 'styled-components';

export const ErrorMessageListStyled = styled.div`
    margin-bottom: 16px;
`;
